import { render } from "./WelcomeView.vue?vue&type=template&id=a51cfc4c&scoped=true"
const script = {}

import "./Index/myIndex.scss?vue&type=style&index=0&id=a51cfc4c&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51cfc4c"]])

export default __exports__